import get from 'lodash/get';
// Actions
export const FETCH_LANGUAGE_LIST = 'FETCH_LANGUAGE_LIST';
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST';

export const FETCH_COUNTRY_LIST = 'FETCH_COUNTRY_LIST';
export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';

export const SET_DEFAULT_TIMEZONE = 'SET_DEFAULT_TIMEZONE';
export const SET_CURRENT_TIMEZONE = 'SET_CURRENT_TIMEZONE';

const initialState = {
  languages: [],
  countries: [],
  languageDictionary: {},
  dialCodeDictionary: {},
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_LANGUAGE_LIST:
      return {
        ...state,
        languages: action.languages,
        languageDictionary: action.dictionary,
      };
    case SET_COUNTRY_LIST:
      return {
        ...state,
        countries: action.countries,
        dialCodeDictionary: action.countryCode,
      };

    case SET_DEFAULT_TIMEZONE:
      return {
        ...state,
        defaultTimezone: action.defaultTimezone,
      };

    case SET_CURRENT_TIMEZONE:
      return {
        ...state,
        timezone: action.timezone,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchLanguageList() {
  return { type: FETCH_LANGUAGE_LIST };
}

export function setLanguageList(languageList, dictionary) {
  return {
    type: SET_LANGUAGE_LIST,
    languages: languageList,
    dictionary: dictionary,
  };
}

export function fetchCountryList() {
  return { type: FETCH_COUNTRY_LIST };
}

export function setCountryList(countryList, countryCode) {
  return {
    type: SET_COUNTRY_LIST,
    countries: countryList,
    countryCode: countryCode,
  };
}

export function setCurrentTimezone(timezone) {
  return {
    type: SET_CURRENT_TIMEZONE,
    timezone,
  };
}

export function setDefaultTimezone(timezone) {
  return { type: SET_DEFAULT_TIMEZONE, defaultTimezone: timezone };
}

// Selectors
export const getLanguageDictionary = state => state.utils.languageDictionary;
export const getCountryCodes = state => state.utils.dialCodeDictionary;
export const getCountryList = state => state.utils.countries;
export const getLanguageList = state => state.utils.languages;
export const getTimezone = state =>
  get(state, 'utils.defaultTimezone', state.utils.timezone);
export const getSystemTimeZone = state =>
  get(state, 'utils.timezone', state.utils.defaultTimezone);
